import { IEirSalesPrequal } from "@modules/eirSalesFacade/interfaces/models/IEirSalesPrequal";
import { CUSTOMER_ALREADY_EXISTS } from "@constants";

export const getIsBroadbandOfferDisplayed = (prequal: IEirSalesPrequal) => prequal.hasBroadbandService;

export const getIsBroadbandNotAvailableDisplayed = (prequal: IEirSalesPrequal) =>
    Boolean(
        (!prequal.hasBroadbandService && !prequal.prequalError) ||
            (prequal.prequalError && prequal.prequalError !== CUSTOMER_ALREADY_EXISTS)
    );

export const getIsBroadbandAlreadyHaveDisplayed = (prequal: IEirSalesPrequal) =>
    Boolean(prequal.prequalError && prequal.prequalError === CUSTOMER_ALREADY_EXISTS);
